import { render, staticRenderFns } from "./SummaryDetailsTable.vue?vue&type=template&id=14493cbb"
import script from "./SummaryDetailsTable.vue?vue&type=script&lang=js"
export * from "./SummaryDetailsTable.vue?vue&type=script&lang=js"
import style0 from "./SummaryDetailsTable.vue?vue&type=style&index=0&id=14493cbb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports